<template>
  <div>
    <div>
      <img src="../assets/download/downBanner.jpg" class="fruit_img"/>
    </div>

    <div style="display: flex;flex-direction: column; justify-content: center;align-items: center">
      <div v-for="(item, index) in delivery" :key="index">
        <a :href="item.url">
          <img class="delivery_border_img" :src="item.img"/>
        </a>
      </div>
    </div>

    <div style="height: 30px"></div>

  </div>
</template>
<script>
export default {
  name: 'Fruit',
  data() {
    return {
      delivery: [
        {
          img: require('../assets/download/cms-maz.png'),
          url: "https://www.khjtecapp.com/smart-camera-ucenter/appfile/CMS.zip",
        },
        {
          img: require('../assets/download/cms.png'),
          url: "https://www.khjtecapp.com/smart-camera-ucenter/appfile/CMS.exe",
        }, {
          img: require('../assets/download/iphone.png'),
          url: "https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1412677608&mt=8",
        }, {
          img: require('../assets/download/android.png'),
          url: "https://android.myapp.com/myapp/detail.htm?apkName=com.nursinghome.monitor&ADTAG=mobile",
        },
      ]
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.delivery_border {
  height: auto;
  margin: 20px;
  width: 55%;
  /*border-radius: 6px;*/
  /*border: 1px solid #EBEEF5;*/
}

.delivery_border_img {
  margin: 20px 0;
  width: 100%;
  height: auto;
}

.load-exe {
  position: absolute;
  top: 35px;
  left: 309px;
  color: #ffffff;
  font-size: 12px;
}

.delivery_border_title {
  margin-top: 10px;
  font-size: 1.25em;
  font-weight: normal;
}

.delivery_border_content {
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: normal;
}

.fruit_img {
  height: auto;
  width: 100%;
}

.fruit_product_img {
  height: 500px;
  width: 260px;
}

.deliver_parent {
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.deliver_img_parent {
  width: 30%;
  height: auto;
}

.delivery {
  display: flex;
  height: 550px;
  width: 90%;
  margin: auto;
  justify-content: center;
  align-items: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .fruit_img {
    height: 250px;
    width: 100%;
  }

  .fruit_product_img {
    height: 400px;
    width: 240px;
  }

  .delivery_border_img {
    margin: 20px;
    width: 90%;
    height: auto;
  }

  .deliver_img_parent {
    width: 100%;
    float: left;
    height: 400px;
  }

  .deliver_parent {
    float: left;
    margin-top: 5px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .delivery_border {
    height: auto;
    margin: 10px 0 auto;
    width: 100%;
    float: right;
    border-radius: 6px;
    border: 1px solid #EBEEF5;
  }

  .delivery {
    display: flex;
    width: 90%;
    height: auto;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .delivery_border_title {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
  }

  .delivery_border_content {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
    margin-bottom: 10px;
  }
}
</style>
